module.exports = __webpack_public_path__ + "static/img/airactiveskinprotection.4fb79463.svg";